import { render, staticRenderFns } from "./EditorialStatsContainer.vue?vue&type=template&id=78f98e89&scoped=true"
import script from "./EditorialStatsContainer.vue?vue&type=script&lang=js"
export * from "./EditorialStatsContainer.vue?vue&type=script&lang=js"
import style0 from "./EditorialStatsContainer.vue?vue&type=style&index=0&id=78f98e89&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f98e89",
  null
  
)

export default component.exports